import {useEffect, useState} from 'react'
import { useTuckshopIDContext } from '../hooks/useTuckshopIDContext'
import ViewtuckshopDetails from '../components/ViewTuckshopDetails'


const Viewtuckshop= () => {

    const {tuckshopid} = useTuckshopIDContext()
    const string = JSON.stringify(tuckshopid)
    const string2 = string.substr(3,24) 
    const [tuckshop,setTuckshop] =useState(null)

useEffect(() => {
 const fetchtuckshop = async () => {
    const response = await fetch('https://webservicetry1.onrender.com/home/viewtuckshops/viewtuckshops')
    const json = await response.json()
    const jsons = json.filter(name => name.user_id === string2)

    if (response.ok) { setTuckshop(jsons)}
 }
fetchtuckshop()
}, [string2])

return (
    <div className='viewtuckshop'>

    <div className='tuckshop'> 
    {tuckshop && tuckshop.map((tuckshop)=> (<ViewtuckshopDetails key={tuckshop._id} tuckshop={tuckshop}/> 

))}
    </div>
    </div>
)
}

export default Viewtuckshop